import {ChangeDetectionStrategy, Component} from "@angular/core";
import {HeaderComponent} from "../../components/header/header.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: "app-account-created",
  templateUrl: "./account-created.component.html",
  styleUrls: ["./account-created.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderComponent, TranslateModule],
})
export class AccountCreatedComponent {}
